import { render, staticRenderFns } from "./OptinOnboardingModal.vue?vue&type=template&id=0e581729&scoped=true"
import script from "./OptinOnboardingModal.vue?vue&type=script&lang=js"
export * from "./OptinOnboardingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e581729",
  null
  
)

export default component.exports